export default "__VITE_ASSET__CssZD4HB__"